import { css, styled } from 'styled-components';

import { InputWrapperProps } from './types';

export const InputWrapper = styled.div<InputWrapperProps>`
  display: flex;
  position: relative;
  background-color: var(--color-white);

  input {
    width: 100%;
    flex: 1 0 0;
    appearance: none;
    background-color: transparent;
    font: inherit;
    padding: var(--spacing-6) var(--spacing-4) var(--spacing-2);
    margin: 0;
    border: 1px solid var(--color-numa-black--200);
    border-radius: 0;
    transition: var(--transition--short);

    &:hover {
      border-color: var(--color-numa-black--300);
    }

    &:focus {
      outline: none;
      border-color: var(--color-primary);
    }

    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    ${({ hasError }) =>
      hasError &&
      css`
        &,
        &:hover,
        &:focus {
          border-color: var(--color-numa-red--100);
        }
      `}

    &:disabled {
      color: var(--color-numa-black--200);
      -webkit-text-fill-color: var(--color-numa-black--200);
      border-color: var(--color-numa-black--100);
      opacity: 1;
    }

    ${({ isQuiet }) =>
      isQuiet &&
      css`
        padding: var(--spacing-4) var(--spacing-2) 0 0;

        &:disabled {
          color: var(--color-numa-black--400);
          -webkit-text-fill-color: var(--color-numa-black--400);
          border-color: transparent;
        }
      `}
  }
`;

export const TogglePasswordVisibility = styled.button`
  position: absolute;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  right: var(--spacing-4);
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background-color: transparent;
  font: var(--font-body-small--medium);
`;
